
import { useState } from 'react'
import './style.scss'
// import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { DashboardSubPages } from '../../types/types'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { useCookies } from 'react-cookie'
import { userStateData } from '../../data/userStateData'

function DashboardInstructorSideMenu() {
	const [menuCollapsed, setMenuCollapsed] = useState<boolean>(false)

	const subPage: string = useAppSelector(state => state.dashboard.subPage)

	const [cookies, setCookie, removeCookie] = useCookies(['userData'])

	const logoutClickHandler = () => {
		userStateData.logOut()
		removeCookie("userData",{
			path: "/"
		})
		window.location.replace(PAGE_URLS.SEARCH)
	}

	return (
		<div className={menuCollapsed ? 'dashboard-instructor-side-menu-wrap dashboard-side-menu-wrap-collapsed' : 'dashboard-instructor-side-menu-wrap'}>
			<div className='dashboard-side-menu-logo-wrap'>
				<a
					className='dashboard-side-menu-logo'
					href={PAGE_URLS.SEARCH}
				>
					<img
						className='dashboard-side-menu-logo-img'
						src={menuCollapsed ? '/imgs/logos/logo-small-over-white.svg' : '/imgs/logos/logo-text.svg'}
						alt='logo'
					/>
				</a>
				<img
					className={menuCollapsed ? 'dashboard-instructor-side-menu-collapse-button dashboard-instructor-side-menu-collapse-button-collapsed' : 'dashboard-instructor-side-menu-collapse-button'}
					src={`/imgs/icons/dashboard/icon-dashboard-collapse.svg`}
					alt='Collapse Button'
					onClick={() => setMenuCollapsed(!menuCollapsed)}
				/>
				<div
					className='user-popup-button dashboard-header-profile-logout-button dashboard-header-profile-logout-button-mobile'
					// href={'/'}
					onClick={() => logoutClickHandler()}
				>Logout</div>
			</div>
			<div className='dashboard-side-menu-button-wrap'>
				{/* <button
					className={subPage === DashboardSubPages.CHATS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => console.log('chat clicked')}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-chat.svg`}
						alt='See Chat Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>See Chats</div>}
				</button> */}
				<button
					// className='dashboard-instructor-side-menu-button'
					className={subPage === DashboardSubPages.REVIEWS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.DASHBOARD_REVIEWS) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-reviews.svg`}
						alt='Reviews Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Reviews</div>}
				</button>
				<button
					// className='dashboard-instructor-side-menu-button'
					className={subPage === DashboardSubPages.BOOKING_DETAILS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.DASHBOARD_BOOKINGS) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-booking.svg`}
						alt='Bookings Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Bookings</div>}
				</button>
				<button
					// className='dashboard-instructor-side-menu-button'
					className={subPage === DashboardSubPages.EARNINGS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
					onClick={() => { window.location.replace(PAGE_URLS.DASHBOARD_EARNINGS) }}
				>
					<img
						className='dashboard-instructor-side-menu-button-icon'
						src={`/imgs/icons/dashboard/icon-dashboard-earnings-side.svg`}
						alt='Saved Instructors Button'
					/>
					{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Earnings</div>}
				</button>
				<div
					className='dashboard-side-menu-bottom-button-wrap'
				>
					<button
						className={subPage === DashboardSubPages.SETTINGS ? 'dashboard-instructor-side-menu-button dashboard-instructor-side-menu-button-selected' : 'dashboard-instructor-side-menu-button'}
						onClick={() => { window.location.replace(PAGE_URLS.DASHBOARD_PROFILE) }}
					>
						<img
							className='dashboard-instructor-side-menu-button-icon dashboard-side-menu-button-icon-white'
							src={`/imgs/icons/dashboard/icon-dashboard-settings-other.svg`}
							alt='Settings Button'
						/>
						{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Settings</div>}
					</button>
					<button
						className='dashboard-instructor-side-menu-button'
						onClick={() => { window.location.replace(PAGE_URLS.DASHBOARD_CUSTOMER) }}
					>
						<img
							className='dashboard-instructor-side-menu-button-icon dashboard-instructor-side-menu-button-icon-white'
							src={`/imgs/icons/dashboard/icon-dashboard-home.svg`}
							alt='Home Button'
						/>
						{!menuCollapsed && <div className='dashboard-instructor-side-menu-button-label'>Home</div>}
					</button>
				</div>
			</div>
		</div>
	)
}

export default DashboardInstructorSideMenu
